module.exports = __webpack_public_path__ + "static/WelcomeToElk10-69457c6b38391b51af9eb27b4815e283.webp";